interface Range {
  min: number;
  max: number;
  color: TypeColorEnum;
};

export enum TypeSpeedEnum {
  Lento = 'lento',
  Medio = 'medio',
  Fluido = 'fluido',
  LimiteVelocidad = 'limVelocidad',

}

export const typeVectorNameMap: { [key: number]: string } = {
  1: 'Genérica',
  2: 'Vías 30',
};

export enum TypeColorEnum {
  Lento = '#FF4545',
  Medio = '#EA9C02',
  Fluido = '#2AC527',
  LimiteVelocidad = '#00C791',
  ExcesoVelocidad = '#4992FF',
}

export const TypeColorMap: { [key: string]: string } = {
  'Lento': '#FF4545',
  'Medio': '#EA9C02',
  'Fluido': '#2AC527',
  'LimiteVelocidad': '#00C791',
  'ExcesoVelocidad': '#4992FF',
}

export const speedGenericaRanges: { [key: string]: Range } = {
  Lento: { min: 0, max: 20, color: TypeColorEnum.Lento },
  Medio: { min: 20.1, max: 30, color: TypeColorEnum.Medio },
  Fluido: { min: 30.1, max: 40, color: TypeColorEnum.Fluido },
  LimiteVelocidad: { min: 40.1, max: 50, color: TypeColorEnum.LimiteVelocidad },
  ExcesoVelocidad: { min: 50.1, max: Infinity, color: TypeColorEnum.ExcesoVelocidad },
};

export const speedVias30Ranges: { [key: string]: Range } = {
  Lento: { min: 0, max: 10, color: TypeColorEnum.Lento },
  Medio: { min: 10.1, max: 15, color: TypeColorEnum.Medio },
  Fluido: { min: 15.1, max: 20, color: TypeColorEnum.Fluido },
  LimiteVelocidad: { min: 20.1, max: 30, color: TypeColorEnum.LimiteVelocidad },
  ExcesoVelocidad: { min: 30.1, max: Infinity, color: TypeColorEnum.ExcesoVelocidad },
};

const getColorForSpeed = (speed: number, ranges: { [key: string]: Range }) => {
  for (const key in ranges) {
    const range = ranges[key];
    if (speed >= range.min && speed <= range.max) {
      return range.color;
    }
  }
  return undefined;
}

export const getColorForSpeedGenerica = (speed: number) => getColorForSpeed(speed, speedGenericaRanges);
export const getColorForSpeedVias30 = (speed: number) => getColorForSpeed(speed, speedVias30Ranges);

export const colorRangeTypeVectorNameMap: { [key: string]: (speed: number) => string | undefined } = {
  ['Genérica']: getColorForSpeedGenerica.bind(this),
  ['Vías 30']: getColorForSpeedVias30.bind(this),
};

